
export default function SearchBar({onSearchtextChange}) {
  
  return (
    <div className="">
      <form>
        <input className="search-inpit" type="text" placeholder="Поиск" onChange={(e) => onSearchtextChange(e.target.value)}/>
      </form>
    </div>
  );
}